'use strict';

import React from 'react';
import 'weui';
import RaceItem from './RaceItem';
import { getData } from '../services/score';

const iconLoading = require('../images/loading.gif');

export default class RaceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: false,
      firstLoading: true,
      filterValue:''
    };
    this.loadRaces = this.loadRaces.bind(this);
  }

  loadRaces(){
    this.setState({ loading: true });
    let pData = getData();
    pData.then((json) => {
      this.setState({
        list: json.races,
        loading: false,
      });
    }).then(() => {
      this.setState({firstLoading: false});
    });
  }

  componentDidMount() {
    this.loadRaces();
    setInterval(this.loadRaces, 20000);
  }

  render() {
    if(this.state.firstLoading){
      return (
          <div className="raceNone">
            <h3><img src={iconLoading} /> 数据加载中...</h3>
            <p>查看全面赛程资讯请使用 <a href="http://www.dszuqiu.com/app">DS足球APP</a></p>
          </div>
        );
    }else{
        if(this.state.list[0]){
          return (
            <div className="raceList">
              <RaceItems races={this.state.list} />
            </div>
          );
        }else{
          return (
            <div className="raceNone">
              <h3>暂时没有正在进行的比赛</h3>
              <p>查看全面赛程资讯请使用 <a href="http://www.dszuqiu.com/app">DS足球APP</a></p>
            </div>
          );
        }
    }
  }
};

const RaceItems = props => {
  const renderItems = () => {
    const races = props.races;
    return (
      races.map(function(race){
        return (
          <RaceItem race={race} key={race.id} />
        );
      })
    );
  };
  return (
    <div>
      {renderItems()}
    </div>
  );
};

RaceList.defaultProps = {
};

export default RaceList;



/** WEBPACK FOOTER **
 ** ./src/components/RaceList.js
 **/